export const business = Object.freeze({
  name: 'Longhorn Milling',
  phoneDisplay: '214-815-5966',
  phoneNumber: '+12148155966',
});

export const phoneHref = `tel:${business.phoneNumber}`;